import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What tools are commonly used in digital marketing?",
    category: "Technology",
    description:
      "Digital marketers use tools like Google Analytics, Google Ads, SEMrush, Ahrefs, Canva, Mailchimp, Meta Ads Manager, and WordPress. These tools help manage campaigns, analyze performance, and optimize digital strategies effectively.",
  },
  {
    title: "What job roles are available in digital marketing?",
    category: "Trending",
    description:
      "What job roles are available in digital marketing?",
  },
  {
    title: "What is SEO and why is it important?",
    category: "Design",
    description:
      "SEO improves website visibility on search engines. It helps attract organic traffic, boosts brand credibility, and increases conversions without paid ads. Good SEO ensures long-term, sustainable audience reach.",
  },
  {
    title: "Is digital marketing a good career?",
    category: "Design",
    description:
      "Yes. Digital marketing is a fast-growing field with strong demand. It offers diverse career paths, flexible work options, high growth potential, and opportunities across all industries.",
  },
  {
    title: "What is influencer marketing?",
    category: "Design",
    description:
      "Influencer marketing involves partnering with content creators or influencers to promote products. It helps brands reach targeted audiences quickly through trusted voices and social media platforms.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
